var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showToolbar
        ? _c(
            "v-toolbar",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.hideTopBar,
                  expression: "hideTopBar"
                }
              ],
              staticClass: "ors-toolbar app-toolbar",
              class: { hidden: !_vm.$store.getters.topBarOpen },
              attrs: { height: "93", app: "", "clipped-left": _vm.clipped }
            },
            [
              _c("a", { attrs: { href: _vm.homeUrl } }, [
                _c("img", {
                  staticClass: "ml-3",
                  attrs: {
                    height: "52.5",
                    src: _vm.getImgSrc("logoImgSrc"),
                    alt: _vm.getConfigVal("appName")
                  }
                })
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-toolbar-items",
                { staticClass: "hidden-sm-and-down" },
                [
                  _vm._l(_vm.menuItems, function(item, index) {
                    return [
                      _c("app-h-menu", {
                        key: index,
                        attrs: { item: item, showIcon: false }
                      })
                    ]
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("v-spacer")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.$store.getters.embed && _vm.$highResolution
        ? _c(
            "v-btn",
            {
              staticClass: "toggle-header",
              staticStyle: {
                width: "38px",
                height: "38px",
                position: "absolute",
                right: "170px",
                "z-index": "4",
                transition: "all 1s ease",
                "border-radius": "5px",
                border: "2px solid rgba(0,0,0,.2)",
                "background-clip": "padding-box",
                "box-shadow": "none"
              },
              style: { top: _vm.$store.getters.topBarOpen ? "103px" : "3px" },
              attrs: {
                fab: "",
                small: "",
                title: _vm.$store.getters.topBarOpen
                  ? _vm.$t("header.hideMenuBar")
                  : _vm.$t("header.showMenuBar")
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.toggleTopBar.apply(null, arguments)
                }
              }
            },
            [
              _vm.$store.getters.topBarOpen
                ? _c("v-icon", { attrs: { large: "" } }, [
                    _vm._v("keyboard_arrow_up ")
                  ])
                : _c("v-icon", { attrs: { large: "" } }, [
                    _vm._v("keyboard_arrow_down ")
                  ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8539ff8c", { render: render, staticRenderFns: staticRenderFns })
  }
}